<template>
  <div>
    <div>
<!--      <el-upload-->
<!--        class="upload-file"-->
<!--        drag-->
<!--        :action="doUpload"-->
<!--        :before-upload="beforeUpload"-->
<!--        ref="newupload"-->
<!--        multiple-->
<!--        :auto-upload="false">-->
<!--        <i class="el-icon-upload"></i>-->
<!--        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
<!--      </el-upload>-->

    </div>
    <el-card>
      下单：<el-date-picker
      v-model="time1"
      type="date"
      format="yyyy-MM-dd"
      placeholder="选择日期"
      style="width: 150px"
    ></el-date-picker>
      —
      <el-date-picker
        v-model="time2"
        type="date"
        format="yyyy-MM-dd"
        placeholder="选择日期"
        style="margin-right: 5px;width: 150px"
      ></el-date-picker>
      状态：
      <el-select class="form-control" style="width: 100px ;margin-right: 5px" v-model="to_State">
        <el-option  v-for="item in options" :key="item.value" :label="item.label" :value="item.value"  >{{item.label,item.value}}</el-option>
      </el-select>
      关键字：
      <el-checkbox v-model="checkedss" style="margin-right: 5px"></el-checkbox>
      <el-input style="width: 150px;margin-right: 5px" type="text" placeholder="客户号/运单编号" v-model="accountNumber" />
      发货：
      <el-date-picker
        v-model="to_outTimeState"
        type="date"
        format="yyyy-MM-dd"
        placeholder="选择日期"
        style="width: 150px"
      ></el-date-picker>
      —
      <el-date-picker
        v-model="to_outTimeEnd"
        type="date"
        format="yyyy-MM-dd"
        placeholder="选择日期"
        style="margin-right: 10px;width: 150px"
      ></el-date-picker>

      <el-button  type="success" @click="selectRowOrder" style="margin-right: 5px">搜索</el-button>
      <el-button v-waves :loading='downloadLoading' class='filter-item' type='primary' icon='el-icon-download' @click='handleUpdate' style="margin-right: 5px">
        导入
      </el-button>
      <el-button  type="success" @click="updateAllState" style="margin-right: 5px">批量修改</el-button>
      <el-button  type="success" @click="deleteAll" style="margin-right: 5px">批量删除</el-button>

      <el-dialog
        title="温馨提示"
        :visible.sync="dialogVisibleDel"
        width="15%"
        append-to-body
      ><el-card style="margin-bottom: 20px">
        <h3>删除的订单不能再找回，请仔细检查</h3>
      </el-card ><el-button @click="dialogVisibleDel = false" style="margin-right: 50px;margin-left: 20px">取 消</el-button>
        <el-button @click="deleteAllById">确定</el-button></el-dialog>
      <el-dialog
        title="请选择要修改的状态"
        :visible.sync="dialogVisibleState"
        width="15%"
        append-to-body
      ><el-card style="margin-bottom: 20px">
        状态：<el-select class="form-control" style="width: 120px ;margin-right: 20px" v-model="to_stateAll">
        <el-option  v-for="item in states" :key="item.value" :label="item.label" :value="item.value"  >{{item.label,item.value}}</el-option>
      </el-select>
      </el-card ><el-button @click="dialogVisibleState = false" style="margin-right: 50px;margin-left: 20px">取 消</el-button>
      <el-button @click="save">确定</el-button></el-dialog>
      <el-dialog
        title="选择上传文件"
        :visible.sync="dialogVisible"
        width="30%"
        append-to-body
      >
        <el-card>
          <span>
          <el-upload class="upload-demo"
                     ref="upload"
                     drag
                     action="http://43.129.236.166:8081/order/exportImport"
                     multiple
                     :limit="1"
                     :on-success="handleFilUploadSuccess"
                     :on-remove="handleRemove"
                     accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传 Excel 文件，且不超过500kb</div>
          </el-upload>

<!--            <el-button type="primary" icon="el-icon-download" @click="chooseFile">导入Excel文件</el-button>-->
        </span>
        </el-card>
        <el-card style="margin-top: 10px">
          <el-button type="primary" icon="el-icon-download" @click="downloadExcel">下载Excel模板</el-button>
        </el-card>
      <span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
<!--				<el-button type="primary" @click="newSubmitForm">上 传</el-button><br>-->
<!--				<el-button type="primary" @click="handleUpload">上 传</el-button><br>-->
			</span>
      </el-dialog>
    </el-card>

    <el-table :data="order" class="tb-edit" style="width: 95%;margin: 20px auto;"  @selection-change="handleSelect">
      <el-table-column type="selection" min-width="5%" align="center" ></el-table-column>
      <el-table-column label="序号" min-width="7%">
        <template slot-scope="scope">
          {{scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column prop="to_orderNumber" label="运单编号" min-width="18%">
      </el-table-column>
      <el-table-column prop="to_account" label="客户号" min-width="12%">
      </el-table-column>
<!--      <el-table-column prop="to_picture" label="物品图片" min-width="18%">-->
<!--        <template slot-scope="scope">-->
<!--          <img width="100px" height="100px" :src="scope.row.to_picture">-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column prop="to_state" label="订单状态" min-width="10%">
        <template slot-scope="scope">
          <p v-if="scope.row.to_state == 0" style="color: red">未发货</p>
          <p v-else-if="scope.row.to_state == 1" style="color: blue">已发货</p>
          <p v-else style="color: green">已收货</p>
        </template>
      </el-table-column>
      <el-table-column prop="to_date" label="下单时间" min-width="15%">
        <template slot-scope="scope">
          <p v-if="scope.row.to_date == null"></p>
          <p v-else>{{scope.row.to_date | moment}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="to_outTime" label="发货时间" min-width="15%">
        <template slot-scope="scope">
          <p v-if="scope.row.to_outTime == null"></p>
          <p v-else>{{scope.row.to_outTime | moment}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="to_endTime" label="收货时间" min-width="15%">
          <template slot-scope="scope">
            <p v-if="scope.row.to_endTime == null"></p>
            <p v-else>{{scope.row.to_endTime | moment}}</p>
        </template>
      </el-table-column>
      <el-table-column  label="操作" min-width="31%" >
        <template slot-scope="scope">
          <el-button icon="el-icon-circle-check" size="small" type="primary"
                     @click="updateUserState(scope.row.to_id)"
                      v-if="scope.row.to_state==0">确定发货</el-button>
          <el-button icon="el-icon-edit" size="small" type="primary"
                     @click="updateOrder(scope.row.to_id,scope.row.to_orderNumber,scope.row.to_account,scope.row.to_picture,scope.row.to_remark,scope.row.to_state,scope.row.to_date)" style="float: right;margin-right: 60px">订单编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;margin-top: 20px;">
      <!--分页组件-->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>

</template>

<script>
  import ImportExcel from "./ImportExcel";
    export default {
      inject:['reload'],
      components: {
        ImportExcel
      },
      data(){
        return {
          precise:0,
          checkedss:false,
          to_outTimeState:null,
          to_outTimeEnd:null,
          options:[
            {label:'请选择',value:null},
            {label:'未发货',value:0},
            {label:'已发货',value:1},
            {label:'已收货',value:2}
          ],
          states:[
            {label:'未发货',value:0},
            {label:'已发货',value:1},
            {label:'已收货',value:2}
          ],
          order: [],
          time1:null,
          time2:null,
          to_State:null,
          accountNumber:'',
          to_remark:'',
          excelImportShow: false,  //导入文件的弹框
          uploadArr: [],   // 上传给后台的数据
          to_orderNumber: '',  // 以下都是我要转换的数据，因人而异
          to_name: '',
          dialogTableVisible: false,
          dialogVisible: false,
          arr:[],
          arrs:[],
          currentPage: 1,
          pageSize: 100,
          total: 0,
          dialogVisibleState:false,
          to_stateAll:0,
          dialogVisibleDel:false,
        };

      },
      mounted() {
        this.accountNumber=this.$route.query.ta_account
        this.handleCurrentChange();
      },

      methods: {
        deleteAllById(){
          this.$confirm('你确定要删除这'+this.arr.length+'个订单记录吗？').then(_ => {
            this.$inbound.post({
              interfaceId: 'order/deleteAllById',
              data: {
                to_id: this.arr,
              }
            }).then(response => {
              window.location.reload()
            }).catch(error => {
              console.log(error)
            })
          }).catch(e=>e);
        },
        save(){
          this.$confirm('你确定要修改他们的状态？').then(_ => {
            this.$inbound.post({
              interfaceId: 'order/updateOrderState',
              data: {
                to_id: this.arr,
                to_state:this.to_stateAll,
              }
            }).then(response => {
              window.location.reload()
            }).catch(error => {
              console.log(error)
            })
          }).catch(e=>e);
        },
        handleSelect(val) {
          this.arr.splice(0,this.arr.length);
          for (var i=0;val.length>i;i++){
            this.arr.push(val[i].to_id)
          }
          // alert(this.arr.length)
          // console.log(this.arr)
        },
        updateAllState(){
          if (this.arr.length>0){
            this.dialogVisibleState=true
            }else{
            this.$message.warning('请选择你要操作的人员');
            }

        },
        deleteAll(){
          if (this.arr.length>0){
            this.dialogVisibleDel=true
          }else{
            this.$message.warning('请选择你要操作的人员');
          }
        },
//
        getTotal(){
          if (this.checkedss==true){
            this.precise=1
          }else{
            this.precise=0
          }
          this.$inbound.post({
            interfaceId: 'order/getTotal',
            data:{
              time1:this.time1,
              time2:this.time2,
              to_state:this.to_State,
              accountNumber:this.accountNumber,
              to_outTimeState:this.to_outTimeState,
              to_outTimeEnd:this.to_outTimeEnd,
              precise:this.precise,
            }
          }).then(response => {
            this.total=response
          }).catch(error => {
            console.log(error)
          })
        },

//
        handleRemove(file,fileList) {
          console.log(file,fileList);
        },
        submitUpload() {
          this.$refs.upload.submit();
        },
        // 文件上传成功时的函数
        handleFilUploadSuccess (res,file,fileList) {

          this.$message.success("上传成功")
          window.location.reload()
          // this.$inbound.post({
          //   interfaceId: 'exportImport',
          //   data: {
          //     file: res.FILE_URL
          //   }
          // }).then(response => {
          //   console.log(response)
          //   window.location.reload()
          // }).catch(error => {
          //   console.log(error)
          // })
        },
        handleUpdate () {
          this.dialogVisible = true;
        },
        // 处理文件上传的函数
        handleUpload () {
          // console.log(file)
          this.submitUpload()
          this.dialogVisible = false
        },
        downloadExcel(){
          window.open("http://43.129.236.166/ImportExcel/wl.xlsx")
        },



        //获取订单信息
        handleCurrentChange(val){
          if (this.checkedss==true){
            this.precise=1
          }else{
            this.precise=0
          }
          this.getTotal();
          this.currentPage=val
          this.$inbound.post({
            interfaceId: 'order/selectRowOrder',
            data:{
              time1:this.time1,
              time2:this.time2,
              to_state:this.to_State,
              accountNumber:this.accountNumber,
              to_outTimeState:this.to_outTimeState,
              to_outTimeEnd:this.to_outTimeEnd,
              page:this.currentPage,
              precise:this.precise,
            }
          }).then(response => {
            this.order=response
            // console.log(this.order)
          }).catch(error => {
            console.log(error)
            this.$message.error('没有相关记录');
          })
        },
        //根据条件查询订单信息
        selectRowOrder(){
          this.handleCurrentChange()
        },
        //编辑订单信息
        updateOrder(to_id,to_orderNumber,to_account,to_picture,to_remark,to_state,to_date){
          this.$router.push({
            path: '/updateOrder',
            query: {
              to_id:to_id,
              to_orderNumber: to_orderNumber,
              to_account: to_account,
              to_picture: to_picture,
              to_remark: to_remark,
              to_state:to_state,
              to_date:to_date,
            }
          })

        },
        updateUserState(id){
          this.arrs=[]
          this.arrs.push(id)
          // alert(this.arrs)
          this.$inbound.post({
            interfaceId: 'order/updateOrderState',
            data: {
              to_id: this.arrs,
              to_state:1
            }
          }).then(response => {
            window.location.reload()
          }).catch(error => {
            console.log(error)
          })
          },
        //获取开始时间
        getStartDate() {
          const d = new Date(this.time1);
          let year = d.getFullYear();
          let month = d.getMonth() + 1;
          let day = d.getDate();
          this.time1 = year + '-' + month + '-' + day;
        },
        //获取结束时间
        getEndDate() {
          const d = new Date(this.time2);
          let year = d.getFullYear();
          let month = d.getMonth() + 1;
          let day = d.getDate();
          this.time2 = year + '-' + month + '-' + day;
        },
        //获取发货开始时间
        getoutTimeState() {
          const d = new Date(this.to_outTimeState);
          let year = d.getFullYear();
          let month = d.getMonth() + 1;
          let day = d.getDate();
          this.to_outTimeState = year + '-' + month + '-' + day;
        },
        //获取发货结束时间
        getoutTimeEnd() {
          const d = new Date(this.to_outTimeEnd);
          let year = d.getFullYear();
          let month = d.getMonth() + 1;
          let day = d.getDate();
          this.to_outTimeEnd = year + '-' + month + '-' + day;
        },

        },

    }
</script>

<style scoped="scoped">
  .btn-upload {
    top: 70px;
    right: 40px;
    position: fixed;
    z-index: 100;
    border-radius: 30px;
    box-shadow: 0 2px 12px 0 rgba(91, 156, 255, 0.9)
  }

  .el-upload {
    margin: 5px;
  }
</style>
